export { default as List } from 'subcompanies/containers/SubcompaniesListContainer';
export { default as Form } from 'subcompanies/containers/SubcompanyFormContainer';



// WEBPACK FOOTER //
// src/modules/secured/modules/subcompanies/containers/index.js